// Mock data for Dr. Akshay Kawedia's website

export const doctorInfo = {
  name: "Dr. Akshay Kawedia",
  qualification: "MBBS, MD Medicine, DM Pulmonary, Critical Care and Sleep Medicine",
  specialization: "Pulmonologist | Critical Care & Sleep Medicine Expert",
  experience: "8+ Years",
  hospitalName: "Kawedia Hospital and Clinic",
  location: "Pune",
  achievement: "All India Rank 1 in INI-Superspeciality Exam",
  institute: "AIIMS New Delhi",
  phone: "9511276806",
  email: "akshaykawedia1@gmail.com",
  address: "2144, MG Road, opp. Poolgate Police Chowky, New Modikhana, Pune 411001",
  whatsapp: "919511276806"
};

export const services = [
  {
    id: 1,
    title: "Asthma & Allergy",
    description: "Comprehensive diagnosis and treatment for asthma and respiratory allergies with personalized care plans.",
    icon: "wind"
  },
  {
    id: 2,
    title: "COPD Management",
    description: "Expert care for Chronic Obstructive Pulmonary Disease with advanced treatment protocols.",
    icon: "activity"
  },
  {
    id: 3,
    title: "Interstitial Lung Disease",
    description: "Specialized treatment for ILD with comprehensive diagnostic and therapeutic approaches.",
    icon: "heart-pulse"
  },
  {
    id: 4,
    title: "Sleep Medicine",
    description: "Advanced diagnosis and treatment for sleep disorders including sleep apnea and insomnia.",
    icon: "moon"
  },
  {
    id: 5,
    title: "Lung Cancer Care",
    description: "Comprehensive lung cancer diagnosis, staging, and treatment planning with multidisciplinary approach.",
    icon: "shield"
  },
  {
    id: 6,
    title: "Pneumonia & TB",
    description: "Expert management of pneumonia and tuberculosis with evidence-based treatment protocols.",
    icon: "thermometer"
  }
];

export const procedures = [
  {
    id: 1,
    title: "Flexible Bronchoscopy",
    description: "Minimally invasive procedure for airway examination and diagnostic sampling."
  },
  {
    id: 2,
    title: "Rigid Bronchoscopy",
    description: "Advanced procedure for complex airway management and foreign body removal."
  },
  {
    id: 3,
    title: "EBUS",
    description: "Endobronchial Ultrasound for precise diagnosis of lung and mediastinal conditions."
  },
  {
    id: 4,
    title: "Thoracoscopy",
    description: "Minimally invasive surgical procedure for diagnosis and treatment of pleural diseases."
  }
];

export const stats = [
  {
    id: 1,
    value: "8+",
    label: "Years of Experience"
  },
  {
    id: 2,
    value: "10,000+",
    label: "Patients Treated"
  },
  {
    id: 3,
    value: "1,000+",
    label: "Procedures Performed"
  }
];

// Animated Statistics for Counter Section
export const animatedStats = [
  {
    id: 1,
    value: 8,
    suffix: "+",
    label: "Years of Experience"
  },
  {
    id: 2,
    value: 5000,
    suffix: "+",
    label: "Patients Treated"
  },
  {
    id: 3,
    value: 1000,
    suffix: "+",
    label: "Procedures Performed"
  }
];

// Disease/Condition Data
export const diseases = [
  {
    id: "asthma",
    title: "Asthma",
    shortDesc: "A chronic respiratory condition causing airway inflammation and breathing difficulties.",
    image: "https://images.pexels.com/photos/30425664/pexels-photo-30425664.jpeg?auto=compress&cs=tinysrgb&w=600",
    symptoms: [
      "Shortness of breath",
      "Chest tightness",
      "Wheezing",
      "Coughing, especially at night",
      "Difficulty sleeping due to breathing problems"
    ],
    causes: [
      "Allergens (pollen, dust mites, pet dander)",
      "Respiratory infections",
      "Physical activity",
      "Cold air",
      "Air pollutants and irritants",
      "Stress and strong emotions"
    ],
    treatment: "Treatment includes inhaled corticosteroids, bronchodilators, and lifestyle modifications. Dr. Kawedia provides personalized asthma action plans."
  },
  {
    id: "copd",
    title: "COPD (Chronic Obstructive Pulmonary Disease)",
    shortDesc: "A progressive lung disease that makes breathing difficult over time.",
    image: "https://images.pexels.com/photos/30425693/pexels-photo-30425693.jpeg?auto=compress&cs=tinysrgb&w=600",
    symptoms: [
      "Chronic cough with mucus",
      "Shortness of breath during activities",
      "Wheezing",
      "Chest tightness",
      "Frequent respiratory infections",
      "Fatigue and lack of energy"
    ],
    causes: [
      "Long-term cigarette smoking",
      "Exposure to air pollution",
      "Occupational dust and chemicals",
      "Genetic factors (Alpha-1 deficiency)",
      "Secondhand smoke exposure"
    ],
    treatment: "Management includes bronchodilators, inhaled steroids, pulmonary rehabilitation, oxygen therapy, and smoking cessation support."
  },
  {
    id: "tuberculosis",
    title: "Tuberculosis (TB)",
    shortDesc: "A bacterial infection primarily affecting the lungs, caused by Mycobacterium tuberculosis.",
    image: "https://images.pexels.com/photos/7579832/pexels-photo-7579832.jpeg?auto=compress&cs=tinysrgb&w=600",
    symptoms: [
      "Persistent cough lasting 3+ weeks",
      "Coughing up blood",
      "Chest pain",
      "Unintentional weight loss",
      "Fatigue and weakness",
      "Fever and night sweats"
    ],
    causes: [
      "Mycobacterium tuberculosis bacteria",
      "Airborne transmission from infected persons",
      "Weakened immune system",
      "Close contact with TB patients",
      "Living in crowded conditions"
    ],
    treatment: "TB requires a 6-9 month course of multiple antibiotics. Early detection and complete treatment are crucial for cure."
  },
  {
    id: "pneumonia",
    title: "Pneumonia",
    shortDesc: "An infection that inflames the air sacs in one or both lungs, filling them with fluid.",
    image: "https://images.pexels.com/photos/3807629/pexels-photo-3807629.jpeg?auto=compress&cs=tinysrgb&w=600",
    symptoms: [
      "High fever with chills",
      "Cough with phlegm",
      "Shortness of breath",
      "Sharp chest pain when breathing",
      "Fatigue and confusion",
      "Nausea and vomiting"
    ],
    causes: [
      "Bacterial infections (Streptococcus)",
      "Viral infections (Influenza, COVID-19)",
      "Fungal infections",
      "Aspiration of food or liquids",
      "Hospital-acquired infections"
    ],
    treatment: "Treatment depends on the cause - antibiotics for bacterial, antivirals for viral, and supportive care including oxygen therapy if needed."
  },
  {
    id: "sleep-apnea",
    title: "Sleep Apnea & Snoring",
    shortDesc: "A sleep disorder where breathing repeatedly stops and starts during sleep.",
    image: "https://images.pexels.com/photos/7556638/pexels-photo-7556638.jpeg?auto=compress&cs=tinysrgb&w=600",
    symptoms: [
      "Loud snoring",
      "Episodes of stopped breathing during sleep",
      "Gasping for air during sleep",
      "Morning headaches",
      "Excessive daytime sleepiness",
      "Difficulty concentrating"
    ],
    causes: [
      "Obesity and excess weight",
      "Narrow airway",
      "Large tonsils or adenoids",
      "Alcohol and sedative use",
      "Smoking",
      "Family history"
    ],
    treatment: "Treatment includes CPAP therapy, lifestyle changes, oral appliances, and in some cases, surgery. Sleep studies help determine the best approach."
  },
  {
    id: "lung-cancer",
    title: "Lung Cancer",
    shortDesc: "A type of cancer that begins in the lungs and is one of the leading causes of cancer deaths.",
    image: "https://images.pexels.com/photos/7579829/pexels-photo-7579829.jpeg?auto=compress&cs=tinysrgb&w=600",
    symptoms: [
      "Persistent cough that worsens",
      "Coughing up blood",
      "Chest pain",
      "Hoarseness",
      "Unexplained weight loss",
      "Bone pain and headaches"
    ],
    causes: [
      "Cigarette smoking (primary cause)",
      "Secondhand smoke exposure",
      "Radon gas exposure",
      "Asbestos and carcinogen exposure",
      "Family history of lung cancer",
      "Air pollution"
    ],
    treatment: "Treatment options include surgery, chemotherapy, radiation therapy, targeted therapy, and immunotherapy based on cancer stage and type."
  },
  {
    id: "allergies",
    title: "Respiratory Allergies",
    shortDesc: "Immune system reactions to airborne substances causing respiratory symptoms.",
    image: "https://images.pexels.com/photos/5858853/pexels-photo-5858853.jpeg?auto=compress&cs=tinysrgb&w=600",
    symptoms: [
      "Sneezing and runny nose",
      "Itchy, watery eyes",
      "Nasal congestion",
      "Coughing and wheezing",
      "Shortness of breath",
      "Skin rashes"
    ],
    causes: [
      "Pollen from trees and grass",
      "Dust mites",
      "Pet dander",
      "Mold spores",
      "Cockroach droppings",
      "Air pollution"
    ],
    treatment: "Management includes allergen avoidance, antihistamines, nasal corticosteroids, and immunotherapy for long-term relief."
  },
  {
    id: "ild",
    title: "Interstitial Lung Disease (ILD)",
    shortDesc: "A group of disorders causing progressive scarring of lung tissue.",
    image: "https://images.pexels.com/photos/4225923/pexels-photo-4225923.jpeg?auto=compress&cs=tinysrgb&w=600",
    symptoms: [
      "Progressive shortness of breath",
      "Dry, hacking cough",
      "Fatigue and weakness",
      "Unexplained weight loss",
      "Chest discomfort",
      "Clubbing of fingers"
    ],
    causes: [
      "Autoimmune diseases",
      "Environmental/occupational exposures",
      "Certain medications",
      "Radiation therapy",
      "Idiopathic (unknown cause)",
      "Genetic factors"
    ],
    treatment: "Treatment may include anti-fibrotic medications, immunosuppressants, oxygen therapy, pulmonary rehabilitation, and lung transplant evaluation."
  }
];

// Blog/Health Articles
export const blogArticles = [
  {
    id: 1,
    title: "When Should You See a Pulmonologist?",
    excerpt: "Learn the warning signs that indicate you need to consult a lung specialist for your respiratory health.",
    image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400",
    date: "Feb 15, 2026",
    readTime: "5 min read",
    content: `Many people wonder when they should see a pulmonologist versus a general physician. Here are key signs:

**You should see a pulmonologist if you experience:**
- Persistent cough lasting more than 3 weeks
- Shortness of breath during normal activities
- Chronic wheezing or chest tightness
- Coughing up blood
- Recurring respiratory infections
- Sleep problems related to breathing

A pulmonologist specializes in diagnosing and treating conditions affecting the lungs and respiratory system. Early consultation can lead to better outcomes.`
  },
  {
    id: 2,
    title: "Understanding Air Pollution and Your Lungs",
    excerpt: "How air pollution affects respiratory health and what you can do to protect yourself.",
    image: "https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?w=400",
    date: "Feb 10, 2026",
    readTime: "4 min read",
    content: `Air pollution is a major threat to respiratory health, especially in urban areas like Pune.

**Effects of air pollution:**
- Aggravates asthma and allergies
- Increases risk of respiratory infections
- Can cause COPD in long-term exposure
- Linked to lung cancer risk

**Protective measures:**
- Use air purifiers at home
- Wear N95 masks on high pollution days
- Avoid outdoor exercise during peak pollution
- Keep indoor plants that purify air
- Regular health checkups for early detection`
  },
  {
    id: 3,
    title: "COVID-19 and Long-Term Lung Health",
    excerpt: "Post-COVID respiratory issues and how pulmonary rehabilitation can help recovery.",
    image: "https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?w=400",
    date: "Feb 5, 2026",
    readTime: "6 min read",
    content: `Many COVID-19 survivors experience persistent respiratory symptoms even after recovery.

**Common post-COVID lung issues:**
- Persistent breathlessness
- Reduced lung capacity
- Chronic fatigue
- Chest pain and tightness
- Persistent cough

**Recovery approaches:**
- Pulmonary function testing
- Breathing exercises
- Gradual physical rehabilitation
- Regular monitoring
- Specialist consultation for severe cases

If you're experiencing post-COVID respiratory symptoms, consult a pulmonologist for proper evaluation.`
  },
  {
    id: 4,
    title: "Sleep Apnea: The Silent Health Threat",
    excerpt: "Why snoring might be more than just annoying - understanding sleep apnea risks.",
    image: "https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=400",
    date: "Jan 28, 2026",
    readTime: "5 min read",
    content: `Sleep apnea affects millions but often goes undiagnosed, leading to serious health complications.

**Health risks of untreated sleep apnea:**
- High blood pressure
- Heart disease and stroke
- Type 2 diabetes
- Depression and mood disorders
- Daytime accidents due to fatigue

**Warning signs:**
- Loud, chronic snoring
- Waking up gasping
- Morning headaches
- Excessive daytime sleepiness

A sleep study can diagnose sleep apnea, and effective treatments like CPAP therapy can dramatically improve quality of life.`
  },
  {
    id: 5,
    title: "Asthma Management: Living Your Best Life",
    excerpt: "Tips and strategies for effectively managing asthma and preventing attacks.",
    image: "https://images.unsplash.com/photo-1584820927498-cfe5211fd8bf?w=400",
    date: "Jan 20, 2026",
    readTime: "4 min read",
    content: `With proper management, people with asthma can lead active, healthy lives.

**Key management strategies:**
- Take controller medications as prescribed
- Always carry rescue inhaler
- Know and avoid your triggers
- Create an asthma action plan
- Monitor symptoms regularly

**Lifestyle tips:**
- Maintain a healthy weight
- Exercise regularly (with precautions)
- Keep home allergen-free
- Get annual flu vaccination
- Regular checkups with your pulmonologist`
  }
];

export const faqs = [
  {
    id: 1,
    question: "What makes Dr. Akshay Kawedia a leading pulmonologist in Pune?",
    answer: "Dr. Akshay Kawedia achieved All India Rank 1 in the INI-Superspeciality Exam and completed his DM in Pulmonary, Critical Care and Sleep Medicine from AIIMS New Delhi. With 8+ years of experience and expertise in interventional pulmonology, he provides world-class respiratory care combining advanced techniques with compassionate patient care."
  },
  {
    id: 2,
    question: "What conditions does Dr. Kawedia treat?",
    answer: "Dr. Kawedia treats a comprehensive range of respiratory conditions including Asthma, COPD, Interstitial Lung Disease, Sleep Disorders, Lung Cancer, Pneumonia, Tuberculosis, and various other breathing-related problems. He also manages critical care cases requiring ventilatory support."
  },
  {
    id: 3,
    question: "What is Interventional Pulmonology?",
    answer: "Interventional Pulmonology involves minimally invasive procedures to diagnose and treat complex lung and airway diseases. Dr. Kawedia is trained in advanced techniques including Flexible and Rigid Bronchoscopy, EBUS (Endobronchial Ultrasound), and Thoracoscopy for precise diagnosis and effective treatment."
  },
  {
    id: 4,
    question: "Does Dr. Kawedia perform bronchoscopy and EBUS?",
    answer: "Yes, Dr. Kawedia is highly skilled in both diagnostic and therapeutic bronchoscopy procedures, including flexible and rigid bronchoscopy. He also performs EBUS for accurate diagnosis of lung cancer, lymph node diseases, and complex airway conditions."
  },
  {
    id: 5,
    question: "How does Dr. Kawedia manage sleep disorders?",
    answer: "Dr. Kawedia offers comprehensive evaluation and treatment for sleep disorders including sleep apnea, snoring, and insomnia. He performs sleep studies, provides CPAP therapy, and offers personalized treatment plans to improve sleep quality and overall health."
  },
  {
    id: 6,
    question: "What are the clinic timings at Kawedia Hospital?",
    answer: "Clinic timings are Monday to Saturday. In-Person consultations: 5:00 PM – 8:00 PM. Online Video consultations: 9:00 PM – 9:30 PM. Sunday is closed. Please contact Kawedia Hospital at 9511276806 for appointment scheduling."
  }
];

export const workingHours = [
  { day: "Monday", hours: "In-Person: 5–8 PM | Online: 9–9:30 PM" },
  { day: "Tuesday", hours: "In-Person: 5–8 PM | Online: 9–9:30 PM" },
  { day: "Wednesday", hours: "In-Person: 5–8 PM | Online: 9–9:30 PM" },
  { day: "Thursday", hours: "In-Person: 5–8 PM | Online: 9–9:30 PM" },
  { day: "Friday", hours: "In-Person: 5–8 PM | Online: 9–9:30 PM" },
  { day: "Saturday", hours: "In-Person: 5–8 PM | Online: 9–9:30 PM" },
  { day: "Sunday", hours: "Closed" }
];